import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';

import Button from '../../components/Button';
import Box from '../../components/layout/Box';
import Text from '../../components/Text';

const CreatedModal = ({ showModal, handleClose }) => {
  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Inlägg skapat</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Box className="flex-column">
          <Text className="mb-3">
            Tack för att du väljer att sälja din kursliteratur här! Ditt inlägg
            kan nu ses av andra studenter.
          </Text>
          <Text>
            Du kan via din profil ändra detaljer i ditt inlägg, samt ta bort
            efter försäljning.
          </Text>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Button backgroundColor="primaryColor" onClick={handleClose}>
          <FormattedMessage defaultMessage="Stäng" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreatedModal;
